// material-ui
import { Theme } from '@mui/material/styles';
import { Box, useMediaQuery } from '@mui/material';

// project-imports
import AccountSwitcher from './AccountSwitcher';
import LanguageToggle from './LanguageToggle';
import Profile from './Profile';
import ThemeModeToggle from './ThemeModeToggle';

import useConfig from 'hooks/useConfig';
import DrawerHeader from 'layout/MainLayout/Drawer/DrawerHeader';

// type
import { MenuOrientation } from 'types/config';

// ==============================|| HEADER - CONTENT ||============================== //

const HeaderContent = () => {
  const { menuOrientation } = useConfig();

  const downLG = useMediaQuery((theme: Theme) => theme.breakpoints.down('lg'));

  return (
    <>
      {menuOrientation === MenuOrientation.HORIZONTAL && !downLG && <DrawerHeader open={true} />}
      <AccountSwitcher />
      <Box sx={{ width: '100%', ml: 1 }} />

      <ThemeModeToggle />
      <LanguageToggle />
      <Profile />
    </>
  );
};

export default HeaderContent;
